module.exports = __webpack_public_path__ + "fonts/SFUIText-MediumItalic.583a02f6.eot";